import { apiPesquisaSatisfacao } from '@/plugins/axios'

export default {
  getPesquisasSatisfacao() {
    return apiPesquisaSatisfacao().get('/satisfacao/relatorios/pesquisas/lazy')
  },
  getTags() {
    return apiPesquisaSatisfacao().get('/satisfacao/relatorios/tags/lazy')
  },
}
